const ApiAttributesKeys = {
  readingNameKey: 'readingName',
  freeQuestionCountKey: 'TotalFreeQuestion',
  TotalQuestionCountKey: 'TotalQuestion',
  chapterIdKey: 'chapterId',
  chapterNameKey: 'chapter_name',
};
module.exports = ApiAttributesKeys;



// WEBPACK FOOTER //
// ./src/views/FRM-V2/Questionbank/QuestionReadingList/ApiAttributesKays.js